import React from 'react';
import { color } from '../tokens';
import Card from './Card';

export interface ResultLine {
  /** Short human label, e.g. «Что» / «Когда» / «Куда». */
  label: string;
  value: string;
}

interface ResultCardProps {
  icon?: React.ReactNode;
  title: string;
  /** Lead-in like «Вот что я сделаю:» */
  heading?: string;
  lines: ResultLine[];
  children?: React.ReactNode;
}

const headingStyle: React.CSSProperties = { fontSize: 13, fontWeight: 600, color: color.textMuted, marginBottom: 10 };
const titleRow: React.CSSProperties = { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 };
const iconStyle: React.CSSProperties = { fontSize: 22 };
const titleStyle: React.CSSProperties = { margin: 0, fontSize: 18, fontWeight: 700, color: color.text };
const listStyle: React.CSSProperties = { display: 'flex', flexDirection: 'column', gap: 10 };
const lineRow: React.CSSProperties = { display: 'flex', gap: 10, alignItems: 'flex-start' };
const lineLabel: React.CSSProperties = { flexShrink: 0, minWidth: 56, color: color.textMuted, fontSize: 14 };
const lineValue: React.CSSProperties = { color: color.text, fontSize: 15, fontWeight: 500 };

/**
 * Human-language «Что будет создано / готово» summary card. No jargon — the
 * cron/webhook/tier details are generated automatically and only surfaced
 * inside ExpertDisclosure.
 */
export default function ResultCard({ icon, title, heading, lines, children }: ResultCardProps) {
  return (
    <Card>
      {heading ? <div style={headingStyle}>{heading}</div> : null}
      <div style={titleRow}>
        {icon ? <span style={iconStyle}>{icon}</span> : null}
        <h3 style={titleStyle}>{title}</h3>
      </div>
      <div style={listStyle}>
        {lines.map((ln, i) => (
          <div key={i} style={lineRow}>
            <span style={lineLabel}>{ln.label}</span>
            <span style={lineValue}>{ln.value}</span>
          </div>
        ))}
      </div>
      {children}
    </Card>
  );
}
